import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-ecommerce")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-ecommerce"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-ecommerce"]!.metaDescription,
    path: "/agente-ia-ecommerce",
  }),
  component: () => <SegmentRoute slug="agente-ia-ecommerce" />,
});
